var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-report',{attrs:{"data":_vm.data,"loaded":_vm.loaded,"loadErr":_vm.loadErr}})
}
var staticRenderFns = []

export { render, staticRenderFns }